import { useEventCallback } from '@cian/react-utils';
import { Button, ModalWindow } from '@cian/ui-kit';
import * as React from 'react';

import { InfrastructureCategory } from '../../components';
import { InfrastructureItem } from '../../components/InfrastructureItem';
import { IInfrastructureCategory, IInfrastructureItem } from 'shared/types/infrastructure';

interface IInfrastructureCategoriesContainerProps {
  regionId: number;
  categories: IInfrastructureCategory[] | null;

  onCategorySelect: (category: string) => void;
  onItemClick: (item: IInfrastructureItem) => void;
  openMapModal: VoidFunction;
  onCategoryModalOpen: (infrastructureType: string) => void;
}

export const InfrastructureCategoriesContainer: React.FC<IInfrastructureCategoriesContainerProps> = ({
  regionId,
  categories,
  onCategorySelect,
  onItemClick,
  openMapModal,
  onCategoryModalOpen,
}) => {
  const [selectedCategory, setSelectedCategory] = React.useState<IInfrastructureCategory | null>(null);

  const handleCategoryClick = useEventCallback((category: IInfrastructureCategory) => {
    setSelectedCategory(category);
    onCategoryModalOpen(category.type);
  });

  const clearSelectedCategory = useEventCallback(() => {
    setSelectedCategory(null);
  });

  const handleItemClick = React.useCallback(
    (category: IInfrastructureCategory, selectedItemIndex: number) => {
      clearSelectedCategory();
      onItemClick(category.items[selectedItemIndex]);
      openMapModal();
    },
    [clearSelectedCategory, onItemClick, openMapModal],
  );

  const showInfrastructureOnMap = React.useCallback(() => {
    if (selectedCategory) {
      clearSelectedCategory();
      onCategorySelect(selectedCategory.type);
      openMapModal();
    }
  }, [clearSelectedCategory, onCategorySelect, openMapModal, selectedCategory]);

  if (!categories) {
    return null;
  }

  return (
    <>
      {categories.map(categoryItem => {
        const { title, type, items, icon } = categoryItem;
        const count = items.length;

        return count > 0 && title ? (
          <InfrastructureCategory
            key={type}
            count={count}
            name={title}
            icon={icon}
            onClick={() => handleCategoryClick(categoryItem)}
          />
        ) : null;
      })}
      {selectedCategory && (
        <ModalWindow
          open
          onClose={clearSelectedCategory}
          title={selectedCategory.title}
          fixed
          content={selectedCategory.items.map((item, index) => (
            <InfrastructureItem
              key={item.id}
              {...item}
              regionId={regionId}
              onClick={() => handleItemClick(selectedCategory, index)}
            />
          ))}
          footer={
            <Button size="L" onClick={showInfrastructureOnMap} fullWidth>
              Смотреть на карте
            </Button>
          }
        />
      )}
    </>
  );
};
